<template>
    <div class="card-margin-bottom">
        <el-row>
            <el-col :span="24">
                <el-checkbox
                    label="Valitse erikseen raportoitavat huonekortit"
                    v-model="huonekorteittain"></el-checkbox>
            </el-col>
        </el-row>
        <el-divider v-if="huonekorteittain" />
        <el-row v-if="huonekorteittain">
            <el-col :span="24">
                <ComHuonekorttiTableWithFilterAndPagination :selection="true" />
            </el-col>
        </el-row>
    </div>
</template>

<script setup lang="ts">
import ComHuonekorttiTableWithFilterAndPagination from "@/components/hanke/huonekortit/table/ComHuonekorttiTableWithFilterAndPagination.vue"
import { defineModel } from "vue"

const huonekorteittain = defineModel<boolean>({ default: false })
</script>
